import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from "react";
export function ErrorBanner({ message, onDismiss }) {
    useEffect(() => {
        const timer = setTimeout(onDismiss, 8_000);
        return () => clearTimeout(timer);
    }, [onDismiss]);
    return (_jsxs("div", { className: "pp-error", role: "alert", children: [_jsx("span", { children: message }), _jsx("button", { type: "button", className: "pp-error__dismiss", onClick: onDismiss, "aria-label": "Dismiss error", children: "\u00D7" })] }));
}
